import { concat, from, mergeMap, MonoTypeOperatorFunction, ObservableInput, share, Subject, takeUntil, toArray } from 'rxjs'

export function waitUntil<T>(notifier$: ObservableInput<any>): MonoTypeOperatorFunction<T> {
  return (source$: Subject<any>) => {
    const sharedSource$ = source$.pipe(share())
    return concat(
      sharedSource$.pipe(
        takeUntil(notifier$),
        toArray(),
        mergeMap(from),
      ),
      sharedSource$,
    )
  }
}
